export default __webpack_public_path__ + "src/images/galleries/1/btn_enter_cn-8dd0f6.png";